import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import MenuIcon from "@mui/icons-material/Menu";
import { FETCH_KPI_REPORTS, GLOBAL_API, GET_TOKEN } from "../api/apiUrls";
import {
  getMonthDropdown,
  getYearDropdown,
  packageCodes,
} from "../static/dropdown";
import Dashboard from "./dashboard/Dashboard";
import { fetchDataByQuery } from "../service/dataExport";

const DepartmentKpi = ({ serverURL, user, setShowSideOverlay }) => {
  const [reports, setReports] = useState({});
  const [intakeCode, setIntakeCode] = useState(null);

  const [location, setLocation] = useState(null);
  const [packages, setPackages] = useState(null);
  const [years, setYears] = useState(null);
  const [months, setMonths] = useState(null);

  const [packageReports, setPackageReports] = useState([]);
  const [intakeOptions, setIntakeOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [queryParams, setQueryParams] = useState({});
  // const fetchKpiReports = async (intakeVal = []) => {
  //   setLoading(true);
  //   setError("");
  //   try {
  //     const res = await axios.post(FETCH_KPI_REPORTS, {
  //       intakeCode: intakeVal ? intakeVal : null,
  //     });
  //     if (res.status === 200 || res.status === 201) {
  //       setReports(res.data || {});
  //     } else {
  //       setError("Failed to fetch KPI Reports.");
  //     }
  //   } catch (err) {
  //     console.error("Error fetching KPI Reports:", err);
  //     setError("Something went wrong while fetching reports.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const reportQuery = {
    totalAssignedUser_query:
      "st.StdName, st.StdCode, st.Stdid, st.PaymentStatus, CASE WHEN st.ststatus = 0 THEN 'Active' WHEN st.ststatus = 3 THEN 'Alumni' WHEN st.ststatus = 5 THEN 'Admission Deffered' WHEN st.ststatus = 6 THEN 'Deffered Active' WHEN st.ststatus = 7 THEN 'Ref/VIP' ELSE 'Unknown' END AS Status, i.Intakename, lo.locname",
    payment_pending_query:
      "st.StdName, st.StdCode, st.Stdid, st.PaymentStatus, CASE WHEN st.ststatus = 0 THEN 'Active' WHEN st.ststatus = 3 THEN 'Alumni' WHEN st.ststatus = 5 THEN 'Admission Deffered' WHEN st.ststatus = 6 THEN 'Deffered Active' WHEN st.ststatus = 7 THEN 'Ref/VIP' ELSE 'Unknown' END AS Status, i.Intakename, lo.locname, a.status",
    visa_amount_pending_query:
      "st.StdName, st.StdCode, st.Stdid, st.PaymentStatus, CASE WHEN st.ststatus = 0 THEN 'Active' WHEN st.ststatus = 3 THEN 'Alumni' WHEN st.ststatus = 5 THEN 'Admission Deffered' WHEN st.ststatus = 6 THEN 'Deffered Active' WHEN st.ststatus = 7 THEN 'Ref/VIP' ELSE 'Unknown' END AS Status, i.Intakename, lo.locname, v.VisaFileStatus",
  };
  const columnDataQuery =
    "st.StdName, st.StdCode, st.Stdid, CASE WHEN st.ststatus = 0 THEN 'Active' WHEN st.ststatus = 3 THEN 'Alumni' WHEN st.ststatus = 5 THEN 'Admission Deffered' WHEN st.ststatus = 6 THEN 'Deffered Active' WHEN st.ststatus = 7 THEN 'Ref/VIP' ELSE 'Unknown' END AS Status, i.Intakename, lo.locname";

  const fetchKpiReports = async (queryParams = {}) => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(FETCH_KPI_REPORTS, queryParams);
      if (res.status === 200 || res.status === 201) {
        setReports(res.data || {});
      } else {
        setError("Failed to fetch KPI Reports.");
      }
    } catch (err) {
      console.error("Error fetching KPI Reports:", err);
      setError("Something went wrong while fetching reports.");
    } finally {
      setLoading(false);
    }
  };

  const fetchCount = async (query) => {
    try {
      const res = await axios.post(GLOBAL_API, {
        mstr: query,
        tokenNumber: GET_TOKEN,
      });
      return res;
    } catch (err) {
      console.error("Error fetching count:", err);
      setError("Something went wrong while fetching reports.");
      return null;
    }
  };

  const fetchReportsForPackages = async (reportData) => {
    if (!reportData || Object.keys(reportData).length === 0) return;
    setLoading(true);
    try {
      const allReports = [];

      for (const pkg of packageCodes) {
        const pkgCode = pkg.value;
        const modiObject = {};

        for (const [key, value] of Object.entries(reportData)) {
          if (!value.query) continue;

          const modifiedQuery = `${value.query} AND st.packageCode = '${pkgCode}'`;
          const res = await fetchCount(modifiedQuery);
          modiObject[key] = res?.data?.[0]?.Column1 || "-";
        }

        allReports.push(modiObject);
      }

      setPackageReports(allReports);
    } catch (error) {
      console.error("Error fetching reports for packages:", error);
      setError("Error fetching detailed package reports.");
    } finally {
      setLoading(false);
    }
  };

  const fetchIntake = async () => {
    try {
      const res = await fetchCount("SELECT * FROM intakemas");
      setIntakeOptions(
        res?.data?.map((item) => ({
          label: item.Intakename,
          value: item.IntakeCode,
        })) || []
      );
    } catch (error) {
      console.error("Error in fetchIntake:", error);
    }
  };
  const fetchLocation = async () => {
    try {
      const res = await fetchCount("SELECT * FROM locmas");
      setLocationOptions(
        res?.data?.map((item) => ({
          label: item.locname,
          value: item.LocCode,
        })) || []
      );
    } catch (error) {
      console.error("Error in fetchIntake:", error);
    }
  };

  const columnData = [
    { label: "Assigned User", value: "totalAssignedUser" },
    { label: "Account Department", value: "Department" },
    { label: "Total Assigned Students", value: "Department" },
    { label: "Registration Pending", value: "registration_pending" },
    {
      label: "Admission Pending (Registration received)",
      value: "admission_amount_pending",
    },
    { label: "Visa Pending", value: "visa_amount_pending" },
    { label: "Completed", value: "payment_completed" },
    { label: "Not Updated", value: "payment_pending" },
    { label: "TAT (IN)", value: "dea" },
    { label: "TAT (OUT)", value: "deo" },
  ];

  const yearDropdown = getYearDropdown();
  const monthDropdown = getMonthDropdown();
  useEffect(() => {
    fetchKpiReports();
    fetchIntake();
    fetchLocation();
  }, []);

  useEffect(() => {
    if (queryParams) {
      fetchKpiReports(queryParams);
    }
  }, [queryParams]);

  useEffect(() => {
    const queryFinal = {
      intake: intakeCode && intakeCode.length > 0 ? intakeCode : [], // Handle multi-select properly
      packageCodes: location ? [location.value] : [], // Single-select, handle correctly
      location: packages ? [packages.value] : [], // Single-select, handle correctly
      year: years ? [years.value] : [], // Single-select, handle correctly
      month: months ? [months.value] : [], // Single-select, handle correctly
    };

    setQueryParams(queryFinal);
  }, [location, packages, years, months, intakeCode]);

  useEffect(() => {
    if (Object.keys(reports).length > 0) {
      fetchReportsForPackages(reports);
    }
  }, [reports]);
  return (
    <>
      <div className="transback h-100 overflow-auto p-3 d-flex flex-column">
        <button
          className="btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2"
          onClick={() => {
            setShowSideOverlay(true);
          }}
        >
          <MenuIcon />
        </button>
        <div className="headerUserDetails py-1 mb-3 border-0 d-flex justify-content-between">
          <span>Department KPI Reports</span>
          <div
            className="d-flex gap-2 align-items-center justify-content-center text-dark px-2"
            style={{ cursor: "pointer" }}
            title={"Name: " + user.name + "\nEmail: " + user.email}
          >
            <i className="fa fa-user"></i>
            <span>{user.name}</span>
          </div>
        </div>
        <div className="w-100 h-100 overflow-auto">
          <div className="container-fluid">
            <div className="row my-3">
              <div className="col-md-3 mb-2">
                <div className="form-group">
                  <label htmlFor="intake-select">Intake</label>
                  <Select
                    id="intake-select"
                    options={intakeOptions}
                    isMulti
                    value={intakeOptions.filter(
                      (option) =>
                        intakeCode && intakeCode.includes(option.value)
                    )}
                    onChange={(selectedOptions) => {
                      setIntakeCode(
                        selectedOptions
                          ? selectedOptions.map((option) => option.value)
                          : []
                      );
                    }}
                    placeholder="Select Intake"
                    isClearable
                  />
                </div>
              </div>

              <div className="col-md-3 mb-2">
                <div className="form-group">
                  <label htmlFor="location-select">Branch</label>
                  <Select
                    id="location-select"
                    options={locationOptions}
                    value={location || null} // ensure it's either null or the selected option object
                    onChange={setLocation}
                    placeholder="Select Branch"
                    isClearable
                  />
                </div>
              </div>

              <div className="col-md-3 mb-2">
                <div className="form-group">
                  <label htmlFor="package-select">Package</label>
                  <Select
                    id="package-select"
                    options={packageCodes}
                    value={packages || null} // ensure it's either null or the selected option object
                    onChange={setPackages}
                    placeholder="Select Package"
                    isClearable
                  />
                </div>
              </div>

              <div className="col-md-3 mb-2">
                <div className="form-group">
                  <label htmlFor="year-select">Year</label>
                  <Select
                    id="year-select"
                    options={yearDropdown.map((item) => ({
                      label: item,
                      value: item,
                    }))}
                    value={years || null} // ensure it's either null or the selected option object
                    onChange={setYears}
                    placeholder="Select Year"
                    isClearable
                  />
                </div>
              </div>

              <div className="col-md-3 mb-2">
                <div className="form-group">
                  <label htmlFor="month-select">Month</label>
                  <Select
                    id="month-select"
                    options={monthDropdown}
                    value={months || null} // ensure it's either null or the selected option object
                    onChange={setMonths}
                    placeholder="Select Month"
                    isClearable
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-2 mb-2">
                <div className="card" style={{minHeight : '149px'}}>
                  <div className="card-body">
                    <div className="d-flex flex-column align-items-center">
                      <span className="h6 fw-bold">Active Registration</span>
                      <span
                        className="h2 fw-bold cursor-pointer"
                        onClick={() =>
                          fetchDataByQuery(
                            reports?.totalAssignedUser?.query,
                            columnDataQuery,
                            "Confirm to download CSV"
                          )
                        }
                      >
                        {reports?.totalAssignedUser?.count ?? 0}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2 mb-2">
                <div className="card" style={{minHeight : '149px'}}>
                  <div className="card-body">
                    <div className="d-flex flex-column align-items-center">
                      <span className="h6 fw-bold">
                        Total Payment Completed
                      </span>
                      <span
                        className="h2 fw-bold cursor-pointer"
                        onClick={() =>
                          fetchDataByQuery(
                            reports?.payment_completed?.query,
                            columnDataQuery,
                            "Confirm to download CSV"
                          )
                        }
                      >
                        {reports?.payment_completed?.count ?? 0}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2 mb-2">
                <div className="card" style={{minHeight : '149px'}}>
                  <div className="card-body">
                    <div className="d-flex flex-column align-items-center">
                      <span className="h6 fw-bold text-center">
                        Registration Amt. Pending
                      </span>
                      <span
                        className="h2 fw-bold cursor-pointer"
                        onClick={() =>
                          fetchDataByQuery(
                            reports?.registration_amount_pending?.query,
                            columnDataQuery,
                            "Confirm to download CSV"
                          )
                        }
                      >
                        {reports?.registration_amount_pending?.count ?? 0}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2 mb-2">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex flex-column align-items-center">
                      <span className="h6 fw-bold text-center">
                        Admission Amt. Pending
                      </span>
                      <span
                        className="h2 fw-bold text-danger cursor-pointer"
                        onClick={() =>
                          fetchDataByQuery(
                            reports?.payment_pending?.query,
                            columnDataQuery,
                            "Confirm to download CSV"
                          )
                        }
                      >
                        {reports?.payment_pending?.count ?? 0}
                      </span>
                    </div>
                    <div className="card-footer">
                      <span className="text-primary text-xs fw-bold text-wrap">
                        <span className="text-dark">
                          {reports?.total_admission_given?.count ?? null}
                        </span>{" "}
                        Admission Given
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2 mb-2">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex flex-column align-items-center">
                      <span className="h6 fw-bold text-center">
                        Visa Amt. Pending
                      </span>
                      <span
                        className="h2 fw-bold"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          fetchDataByQuery(
                            reports?.visa_amount_pending?.query,
                            columnDataQuery,
                            "Confirm to download CSV"
                          )
                        }
                      >
                        {reports?.visa_amount_pending?.count ?? 0}
                      </span>
                    </div>
                    <div className="card-footer">
                      <span className="text-primary fw-bold text-xs">
                        <span className="text-dark">
                          {reports?.total_visa_appo_booked?.count ?? null}{" "}
                        </span>{" "}
                        Appointment Booked
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2 mb-2">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex flex-column align-items-center">
                      <span className="h6 fw-bold text-center">
                        Accomodation Amt. Pending
                      </span>
                      <span
                        className="h2 fw-bold"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          fetchDataByQuery(
                            reports?.accomodation_amount_pending?.query,
                            columnDataQuery,
                            "Confirm to download CSV"
                          )
                        }
                      >
                        {reports?.accomodation_amount_pending?.count ?? 0}
                      </span>
                    </div>
                    <div className="card-footer">
                      <span className="text-primary fw-bold text-xs">
                        <span className="text-dark">
                          {reports?.total_accomodation_amount?.count ?? null}{" "}
                        </span>{" "}
                        Accomodation Given
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-3">
                <div className="card">
                  <div className="card-body d-flex flex-column gap-2">
                    <div className="w-100 d-flex gap-1">
                      <span className="h6 fw-bold">Active Registration</span>
                      <span
                        className="h2 fw-bold cursor-pointer"
                        onClick={() =>
                          fetchDataByQuery(
                            reports?.totalAssignedUser?.query,
                            columnDataQuery,
                            "Confirm to download CSV"
                          )
                        }
                      >
                        {reports?.totalAssignedUser?.count ?? 0}
                      </span>
                    </div>
                  </div>
                </div>
              </div> */}
              {/* <div className="col-md-3">
                <div className="card w-100">
                  <div className="card-body d-flex flex-column gap-2">
                    <div className="w-100 d-flex gap-1">
                      <span className="h6 fw-bold">
                        Total Payment Completed
                      </span>
                      <span
                        className="h2 fw-bold cursor-pointer"
                        onClick={() =>
                          fetchDataByQuery(
                            reports?.payment_completed?.query,
                            columnDataQuery,
                            "Confirm to download CSV"
                          )
                        }
                      >
                        {reports?.payment_completed?.count ?? 0}
                      </span>
                    </div>
                  </div>
                </div>
              </div> */}
              {/* <div className="col-md-3">
                <div className="card w-100">
                  <div className="card-body d-flex flex-column gap-2">
                    <div className="w-100 d-flex gap-1">
                      <span className="h6 fw-bold">
                        Registration Amount Pending
                      </span>
                      <span
                        className="h2 fw-bold cursor-pointer"
                        onClick={() =>
                          fetchDataByQuery(
                            reports?.registration_amount_pending?.query,
                            columnDataQuery,
                            "Confirm to download CSV"
                          )
                        }
                      >
                        {reports?.registration_amount_pending?.count ?? 0}
                      </span>
                    </div>
                  </div>
                </div>
              </div> */}
              {/* <div className="col-md-3">
                <div className="card w-100">
                  <div className="card-body d-flex flex-column gap-2">
                    <div className="w-100 d-flex gap-1">
                      <span className="h6 fw-bold text-danger">
                        Admission Amount Pending
                      </span>
                      <span
                        className="h2 fw-bold text-danger cursor-pointer"
                        onClick={() =>
                          fetchDataByQuery(
                            reports?.payment_pending?.query,
                            columnDataQuery,
                            "Confirm to download CSV"
                          )
                        }
                      >
                        {reports?.payment_pending?.count ?? 0}
                      </span>
                    </div>
                    <span className="text-primary text-xs fw-bold text-wrap">
                      <span className="text-dark">
                        {reports?.total_admission_given?.count ?? null}
                      </span>{" "}
                      Admission Given
                    </span>
                  </div>
                </div>
              </div> */}
              {/* <div className="col-md-3">
                <div className="card w-100">
                  <div className="card-body d-flex flex-column gap-2">
                    <div className="w-100 d-flex gap-1">
                      <span className="h6 fw-bold">Visa Amount Pending</span>
                      <span
                        className="h2 fw-bold"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          fetchDataByQuery(
                            reports?.visa_amount_pending?.query,
                            columnDataQuery,
                            "Confirm to download CSV"
                          )
                        }
                      >
                        {reports?.visa_amount_pending?.count ?? 0}
                      </span>
                    </div>

                    <span className="text-primary fw-bold text-xs">
                      <span className="text-dark">
                        {reports?.total_visa_appo_booked?.count ?? null}{" "}
                      </span>{" "}
                      Appointment Booked
                    </span>
                  </div>
                </div>
              </div> */}
              {/* <div className="col-md-3">
                <div className="card w-100">
                  <div className="card-body d-flex flex-column gap-2">
                    <div className="w-100 d-flex gap-1">
                      <span className="h6 fw-bold">
                        Accomodation Amount Pending
                      </span>
                      <span
                        className="h2 fw-bold"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          fetchDataByQuery(
                            reports?.accomodation_amount_pending?.query,
                            columnDataQuery,
                            "Confirm to download CSV"
                          )
                        }
                      >
                        {reports?.accomodation_amount_pending?.count ?? 0}
                      </span>
                    </div>
                    <span className="text-primary fw-bold text-xs">
                      <span className="text-dark">
                        {reports?.total_accomodation_amount?.count ?? null}{" "}
                      </span>{" "}
                      Accomodation Given
                    </span>
                  </div>
                </div>
              </div> */}
            </div>
            <Dashboard
              reportQuery={reports}
              columnData={columnData}
              packageReports={packageReports}
            />
            {/* <div className="row">
              {loading && (
                <p className="text-center text-light">Loading reports...</p>
              )}
              {error && <p className="text-danger">{error}</p>}
              {!loading && !error && packageReports.length > 0 && (
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Metric</th>
                      {packageCodes.map((pkg) => (
                        <th key={pkg.value} className="text-nowrap">
                          {pkg.label}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {columnData.map((col, idx) => (
                      <tr key={idx}>
                        <td className="text-nowrap">{col.label}</td>
                        {packageReports.map((pkg, i) => (
                          <td key={i}>
                            {pkg[col.value] !== undefined
                              ? pkg[col.value]
                              : "-"}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default DepartmentKpi;
